import styled from 'styled-components';

const Headline = styled.div`
  font-size: 14px;
  color: #2e4964;
  font-weight: 700;
  margin: 15px 0;
`;

export default Headline;
